/**
 * Base css generation and global js logic.
 */

import 'tokens/sass/tokens.scss';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

Alpine.plugin(collapse);
Alpine.start();

export default {};
